import { Button } from '@material-ui/core';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { SignUpWelcomeContainer } from '../sign-up-welcome';
import { MatField } from 'src/core/components/mat-field';
import { PageError } from 'src/core/components/page-error/page-error';

const emailErrorMap = {
    required: 'This field is required.',
    email: 'Invalid email address.',
};

interface Props {
    container: SignUpWelcomeContainer;
}

export const SignUpWelcome = observer<React.SFC<Props>>(({ container: { data } }) => (
    <div className="page page-inverted login-image-background">
        <div className="page-topping">
            <PageError absolute message={data.errorMessage} onClose={data.clearError} />
        </div>

        <div className="card">
            <form className="flex-form" onSubmit={data.handleSubmit}>
                <h1>Welcome {data.firstName}</h1>
                <div className="card-content">
                    <p>Confirm your email address.</p>
                    <div className={classnames('form-field', 'single-input')}>
                        <MatField
                            fullWidth
                            type="email"
                            name="email"
                            label="Email"
                            fieldState={data.email}
                            errorMap={emailErrorMap}
                            autoFocus
                            readOnly
                        />
                    </div>
                </div>
                <div className="space-filler" />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="next-step-button"
                    disabled={data.form.hasError}
                >
                    Continue
                </Button>
            </form>
        </div>
    </div>
));
